import React from 'react'
import { Heading, Pane } from 'evergreen-ui'

const ErrorBoundryFallback = () => {
  return (
    <Pane
      style={{
        textAlign: 'center',
        padding: '100px 0',
        maxWidth: '70%',
        margin: '0 auto'
      }}
    >
      <Heading size={900}>
        <span role='img' aria-label='sad face emoji'>
          🤦‍♂️
        </span>
        Ooops! Please refresh this page.
      </Heading>
      <Heading size={400} marginTop={50}>
        It seems that we have a little technical problem here. An alert has been
        sent to our team and we will investigating this as soon as possible.
        Please try refreshing.
      </Heading>
    </Pane>
  )
}

export default ErrorBoundryFallback
